import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useStore } from "../../../contexts/StoreProvider";
import FriendRequestPopupHOC from "../hoc/FriendRequestPopupHOC";
import InviteFriend from "./InviteFriend";
import { SendFriendRequestEnum, UserType } from "../../../constants/enum";
import IGetSendFriendRequest from "../../../models/Form/IGetSentFriendRequest";
import LoaderButton from "../../../shared-components/Button/LoaderButton";
import { FormattedMessage } from "react-intl";
import DeletePopup from "../../agent-dashboard/components/Delete/DeletePopup";
import { formatMessage } from "../../../translations/format-message";
import DeletePopupHOC from "../../agent-dashboard/hoc/DeletePopupHOC";
import { useNavigate } from "react-router-dom";
import RoutesConstants from "../../../shared-components/Routes/routes.constants";
import { ITestInfo } from "../../../models/ITestInfo";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserGroup } from "@fortawesome/free-solid-svg-icons";
import ConfirmPopupHOC from "../../../shared-components/confirmationPopup/hoc/confirmation-popup-hoc";
import ConfirmPopup from "../../../shared-components/confirmationPopup/confirm-popup";


const FriendRequest = (props: any) => {
    const { setSelectedTestsForComparison, selectedTestsForComparison } = props
    const navigate = useNavigate();
    const { authStore } = useStore();
    const {allTest, getUserType, getAllFriendRequests, allSendFriendRequest, getSendFriendRequestState,
        allSendFriendRequestReceived, allSendFriendRequestSend, getSendFriendRequestStateSend, getSendFriendRequestStateReceived,
        UpdateStatus, UpdateStatusState, DeleteRequest, DeleteRequestState, CancelRequestState, DeleteFriendsState, 
        CancelRequest, DeleteFriends, resetCancelRequest, resetDeleteFriends, resetDeleteRequest, resetUpdateStatus, 
        getSendFriendRequestsSend, getSendFriendRequestsReceived, testDataList } = authStore
    const [deleteInvitesId, setDeleteInvitesId] = useState<number>(-1);
    const [deleteInvitesName, setDeleteInvitesName] = useState<string>("");
    const [selectedId, setSelectedId] = useState<number>(0);
    const handleCreateSentFriendRequestModalClose = () => {
        props.friendRequestPopupToggleHandler();
    }

    const handleCreateSentFriendRequestModalOpen = () => {
        props.friendRequestPopupToggleHandler();
    }

    useEffect(() => {
        getAllFriendRequests()
        getSendFriendRequestsReceived(SendFriendRequestEnum.Received)
        getSendFriendRequestsSend(SendFriendRequestEnum.Send)
    }, [])

    useEffect(() => {
        if (getSendFriendRequestState.success) {
            // let findingFriendList = allSendFriendRequest.filter((old: any) => old.Status === 'friends')
            // setFriends(findingFriendList)
            getSendFriendRequestState.success = !getSendFriendRequestState.success
        }
        if (getSendFriendRequestStateSend.success) {
            // let findingSendList = allSendFriendRequestSend.filter((old: any) => old.Status === 'Pending')
            // setSend(findingSendList)
            getSendFriendRequestStateSend.success = !getSendFriendRequestStateSend.success
        }
        if (getSendFriendRequestStateReceived.success) {
            // let findingReceivedList = allSendFriendRequestReceived.filter((old: any) => old.Status === 'Pending')
            // setReceived(findingReceivedList)
            getSendFriendRequestStateReceived.success = !getSendFriendRequestStateReceived.success
        }
    }, [getSendFriendRequestState.success, getSendFriendRequestStateSend.success, getSendFriendRequestStateReceived.success])

    useEffect(() => {
        if (DeleteRequestState.success) {
            getAllFriendRequests()
            getSendFriendRequestsReceived(SendFriendRequestEnum.Received)
            getSendFriendRequestsSend(SendFriendRequestEnum.Send)
            resetDeleteRequest();
        }
    }, [DeleteRequestState.success])

    useEffect(() => {
        if (UpdateStatusState.success) {
            getAllFriendRequests()
            getSendFriendRequestsReceived(SendFriendRequestEnum.Received)
            getSendFriendRequestsSend(SendFriendRequestEnum.Send)
            resetUpdateStatus();
        }

    }, [UpdateStatusState.success])

    useEffect(() => {
        if (CancelRequestState.success) {
            getAllFriendRequests()
            getSendFriendRequestsReceived(SendFriendRequestEnum.Received)
            getSendFriendRequestsSend(SendFriendRequestEnum.Send)
            resetCancelRequest();
        }

    }, [CancelRequestState.success])

    useEffect(() => {
        if (DeleteFriendsState.success) {
            getAllFriendRequests()
            getSendFriendRequestsReceived(SendFriendRequestEnum.Received)
            getSendFriendRequestsSend(SendFriendRequestEnum.Send)
            props.deletePopupToggleHandler();
            resetDeleteFriends();
        }
    }, [DeleteFriendsState.success])

    const hangleClickId = (id: any) => {
        UpdateStatus(id)
    }

    const handleDeleteRequest = (id: any) => {
        DeleteRequest(id)
    }
    const handleDeleteFriends = (eventId: number, invitesName: string, event: any) => {
        const isButtonDisabled = event.currentTarget.disabled;
        if (!isButtonDisabled) {
            setDeleteInvitesId(eventId);
            setDeleteInvitesName(invitesName);
            props.deletePopupToggleHandler();
        }
    }

    const deleteInvitesHandler = (id: number) => {
        DeleteFriends(id)
    }
    const handleCancelRequest = (id: any) => {
        props.confirmToggleHandler()
        setSelectedId(id)

    }
    const handleRemoveFromCompariosn = (id: any) => {
        const testToBeRemoved = selectedTestsForComparison.filter((testId: any) => testId != id)
        setSelectedTestsForComparison(testToBeRemoved)
    }

    const handleAddToComparison = (id: any) => {
        const testToBeAdded = allSendFriendRequest.find((old: IGetSendFriendRequest) => old.TestId === id)?.TestId
        setSelectedTestsForComparison([...selectedTestsForComparison, testToBeAdded])
    }

    const handleTestCompare = (id: number) => {
        const userLatestTest = Math.max(...testDataList.TestList.map((test: ITestInfo) => Number(test.TestDate)));
        const latestTest = testDataList.TestList.find((test: ITestInfo) => Number(test.TestDate) == userLatestTest);
        if (latestTest?.TestId)
            navigate(`${RoutesConstants.TestResultCompare}?testId=${latestTest?.TestId}&testId=${id}`);
        else
            toast.error(formatMessage('SomethingWentWrong'));
    }
    const CancelRequestHandler = () => {
        CancelRequest(selectedId)
        props.confirmToggleHandler()
    };

    return (
        <>
            {props.showFriendRequestPopup && (
                <InviteFriend modalClosed={handleCreateSentFriendRequestModalClose} />
            )}
            {props.showDeletePopup && (
                <DeletePopup modalClosed={props.deletePopupToggleHandler} isLoading={DeleteFriendsState.inProgress} Id={deleteInvitesId} Title={deleteInvitesName} deleteHandler={deleteInvitesHandler} />
            )}
            {props.showConfirmPopup && (
                <ConfirmPopup
                    title="Cancel_Request"
                    modalSubmit={CancelRequestHandler}
                    modalClosed={props.confirmToggleHandler}
                    message="Are you sure you want to cancel this friend request?"
                    dialogClassName="confirm_popup"
                    isLoading={CancelRequestState.inProgress}
                />
            )}
            <div className="dashboardTopbar">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-7">
                            <p className="text-dark"><FormattedMessage id="total_friends" />: {allSendFriendRequest.length}</p>
                        </div>
                        <div className="col-5 text-end">
                            <button className="btn btn-primary"
                                onClick={handleCreateSentFriendRequestModalOpen}><i className="fa fa-users"></i> &nbsp;
                                <FormattedMessage id="Friend_Request_Invite" /></button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row flex-lg-row-reverse">
                    <div className="col-lg-5 col-xl-4 col-12">
                        <h3 className="section-small-title"><FormattedMessage id="Suspended_Requests_Title" /></h3>
                        <div className="friendListCard">
                            {
                                allSendFriendRequestSend.length > 0 ? (
                                    <>
                                        {
                                            allSendFriendRequestSend.map((key) => {
                                                return <>
                                                    <div className="friendList-item">
                                                        <div className="row">
                                                            <div className="col-7 d-flex align-items-center">
                                                                <p className="mb-0 text-dark" title={key.UserReceiverEmailId}>{key.UserReceiverEmailId}</p>
                                                            </div>
                                                            <div className="col-5 text-end">
                                                                <button className="btn btn-outline-primary btn-sm me-2"><FormattedMessage id="Resend_Button" /></button>
                                                                <button className="btn btn-link text-danger" title={formatMessage('delete')}
                                                                    onClick={() => handleCancelRequest(key.RequestId)}>
                                                                        <i className="fa fa-trash-alt"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            })
                                        }
                                    </>
                                ) : (
                                    <div className="d-flex flex-column justify-content-center align-items-center h-100">
                                        <p className="noData text-muted text-center h5 mb-0"><FormattedMessage id="no_request_sent" /></p>
                                    </div>
                                )
                            }
                        </div>
                        {
                            allSendFriendRequestReceived.length > 0 && (
                                <>
                                    <h3 className="section-small-title"><FormattedMessage id="Recevied_Title" /></h3>
                                    <div className="friendListCard">
                                        {
                                            allSendFriendRequestReceived.map((key) => {
                                                return <>
                                                    <div className="friendList-item">
                                                        <div className="row">
                                                            <div className="col-7">
                                                                <p className="mb-0">{key.SenderName}<br /><small className="text-muted">{key.UserReceiverEmailId}</small></p>
                                                            </div>
                                                            <div className="col-5 text-end">
                                                                <LoaderButton
                                                                    type="submit"
                                                                    id="AcceptRequest"
                                                                    className="btn btn-outline-success btn-sm me-2"
                                                                    form="AcceptRequest"
                                                                    isLoading={UpdateStatusState.inProgress}
                                                                    onClick={() => hangleClickId(key.RequestId)}
                                                                    text={"Accept Request"}
                                                                />
                                                                <button className="btn btn-link text-danger" title={formatMessage('delete')}
                                                                    onClick={() => handleCancelRequest(key.RequestId)}>
                                                                        <i className="fa fa-trash-alt"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            })
                                        }
                                    </div>
                                </>
                            )
                        }
                    </div>
                    <div className="col-lg-7 col-xl-8 col-12">
                        {
                            allSendFriendRequest.length > 0 ? (
                                <>
                                    <h3 className="section-small-title"><FormattedMessage id="Your_Friends_Title" /></h3>
                                    <div className="row">
                                        {
                                            allSendFriendRequest.map((item) => {
                                            return <>
                                                <div className="col-xl-4 col-sm-6 col-12 mb-3 text-center">
                                                    <div className="card border-card">
                                                        <div className="card-body">
                                                            <h3 className="mb-0">{item.SenderName}</h3>
                                                            <p>{item.UserReceiverEmailId}</p>
                                                            { item.UserType === 'Admin' ? (
                                                                <span className='badge bg-primary'>
                                                                    {item.UserType}
                                                                </span>
                                                            ) : item.UserType === 'Trainer' ? (
                                                                <span className='badge bg-success'>
                                                                    {item.UserType}
                                                                </span>
                                                            ) : item.UserType === 'Personal' ? (
                                                                <span className='badge bg-warning'>
                                                                    {item.UserType}
                                                                </span>
                                                            ) : (
                                                                <span className='badge bg-dark'>
                                                                    {item.UserType}
                                                                </span>
                                                            )}
                                                            <div className="mt-3">
                                                                <button className='btn btn-sm btn-outline-danger' onClick={(e) => handleDeleteFriends(item.RequestId, item.UserReceiverEmailId, e)} title={formatMessage('delete')} disabled={item.UserReceiverEmailId == ''}>
                                                                    <svg version="1.1" id="Layer_1" viewBox="0 0 512 512" >
                                                                        <g>
                                                                            <g>
                                                                                <path d="M62.205,150l26.569,320.735C90.678,493.865,110.38,512,133.598,512h244.805c23.218,0,42.92-18.135,44.824-41.265
            L449.795,150H62.205z M180.986,452c-7.852,0-14.458-6.108-14.956-14.063l-15-242c-0.513-8.276,5.771-15.395,14.033-15.908
            c8.569-0.601,15.381,5.757,15.908,14.033l15,242C196.502,444.632,189.721,452,180.986,452z M271,437c0,8.291-6.709,15-15,15
            c-8.291,0-15-6.709-15-15V195c0-8.291,6.709-15,15-15s15,6.709,15,15V437z M360.97,195.938l-15,242
            c-0.493,7.874-7.056,14.436-15.908,14.033c-8.262-0.513-14.546-7.632-14.033-15.908l15-242
            c0.513-8.276,7.764-14.297,15.908-14.033C355.199,180.543,361.483,187.662,360.97,195.938z"/>
                                                                            </g>
                                                                        </g>
                                                                        <g>
                                                                            <g>
                                                                                <path d="M451,60h-90V45c0-24.814-20.186-45-45-45H196c-24.814,0-45,20.186-45,45v15H61c-16.569,0-30,13.431-30,30
            c0,16.567,13.431,30,30,30c137.966,0,252.039,0,390,0c16.569,0,30-13.433,30-30C481,73.431,467.569,60,451,60z M331,60H181V45
            c0-8.276,6.724-15,15-15h120c8.276,0,15,6.724,15,15V60z"/>
                                                                            </g>
                                                                        </g>
                                                                    </svg>
                                                                </button>
                                                                {
                                                                    getUserType === UserType.Personal 
                                                                    ?
                                                                        <>
                                                                            <button className='btn btn-outline-primary btn-sm ms-2' disabled={(allTest?.length == 0 || !(item.TestId)) ? true : false} 
                                                                                    onClick={() => item.TestId ? handleTestCompare(item.TestId) : null} title={formatMessage('compare')}>
                                                                                <FontAwesomeIcon icon={faUserGroup} />
                                                                            </button>
                                                                        </>
                                                                    :
                                                                    (selectedTestsForComparison.filter((testId: any) => testId === item.TestId).length === 1) && item.UserReceiverEmailId && item.TestId ?
                                                                        <button className='btn btn-primary btn-sm ms-2' onClick={() => handleRemoveFromCompariosn(item.TestId)} title={formatMessage('remove_from_comparison')}>
                                                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                                                            viewBox="0 0 512 512"><path d="M76.8,212.3c0-63.6,51.6-115.2,115.2-115.2c63.6,0,115.2,51.6,115.2,115.2c0,63.6-51.6,115.2-115.2,115.2
                                                                        C128.4,327.5,76.8,275.9,76.8,212.3z"/>
                                                                            <path d="M67.6,371c31.6-13.7,72.9-17.9,124.4-17.9c51.5,0,92.9,4.2,124.5,17.9c34.4,14.9,55.3,40.4,66.2,76.4
                                                                        c5.1,16.9-7.5,33.7-25,33.7H26.3c-17.5,0-30.1-16.9-25-33.8C12.3,411.4,33.2,385.9,67.6,371L67.6,371z"/>
                                                                            <path d="M384,97.1h-51.2c-14.1,0-25.6,11.5-25.6,25.6s11.5,25.6,25.6,25.6H384h51.2h51.2c14.1,0,25.6-11.5,25.6-25.6
                                                                        s-11.5-25.6-25.6-25.6h-51.2H384z"/>
                                                                            </svg>
                                                                        </button>
                                                                        :
                                                                        <button className='btn btn-outline-primary btn-sm ms-2' disabled={item.TestId ? false : true} onClick={() => item.TestId ? handleAddToComparison(item.TestId) : null} title={formatMessage('add_to_comparison')}>
                                                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                                                            viewBox="0 0 512 512"><path d="M76.8,212.3c0-63.6,51.6-115.2,115.2-115.2c63.6,0,115.2,51.6,115.2,115.2c0,63.6-51.6,115.2-115.2,115.2
                                                                        C128.4,327.5,76.8,275.9,76.8,212.3z"/>
                                                                            <path d="M67.6,371c31.6-13.7,72.9-17.9,124.4-17.9c51.5,0,92.9,4.2,124.5,17.9c34.4,14.9,55.3,40.4,66.2,76.4
                                                                        c5.1,16.9-7.5,33.7-25,33.7H26.3c-17.5,0-30.1-16.9-25-33.8C12.3,411.4,33.2,385.9,67.6,371L67.6,371z"/>
                                                                            <path d="M435.2,45.9c0-14.1-11.5-25.6-25.6-25.6S384,31.7,384,45.9v51.2h-51.2c-14.1,0-25.6,11.5-25.6,25.6s11.5,25.6,25.6,25.6H384
                                                                        v51.2c0,14.1,11.5,25.6,25.6,25.6s25.6-11.5,25.6-25.6v-51.2h51.2c14.1,0,25.6-11.5,25.6-25.6s-11.5-25.6-25.6-25.6h-51.2V45.9z"/>
                                                                            </svg>
                                                                        </button>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>;
                                        })}
                                    </div>
                                </>
                            ) : (
                                <div className="d-flex flex-column justify-content-center align-items-center">
                                    <svg clip-rule="evenodd" fill-rule="evenodd" height="120" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 64 64" width="120" xmlns="http://www.w3.org/2000/svg"><g id="Exp-2.-F"><path d="m37.953 39.368 3.24-6.643h-14s-3.126 6.411-4.559 9.348c-.151.31-.132.675.051.968.183.292.503.47.848.47h6.027l-4.779 11.827c-.176.437-.024.938.366 1.202.39.265.912.221 1.253-.105 4.544-4.349 12.487-11.95 16.034-15.344.295-.283.388-.716.236-1.095s-.519-.628-.928-.628z" fill="#347bfa" /><g fill="#a4bbdb"><path d="m5.772 47.451c-.524.907-1.033 1.789-1.5 2.598-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.467-.809.976-1.691 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366zm5.5-9.526s-.602 1.042-1.5 2.598c-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.898-1.556 1.5-2.598 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366z" /><path d="m39.125 53.745c-.57.987-1.089 1.887-1.5 2.598-.276.478-.112 1.091.366 1.366.478.276 1.09.112 1.366-.366.411-.711.93-1.611 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366zm5.5-9.526s-.614 1.063-1.5 2.598c-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.886-1.535 1.5-2.598 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366z" /><path d="m47.937 50.89c-.684 1.185-1.149 1.991-1.149 1.991-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c0 0 .465-.806 1.149-1.991.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366zm5.5-9.526s-.629 1.089-1.5 2.598c-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.871-1.509 1.5-2.598 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366z" /><path d="m9.658 53.158c-.736 1.276-1.244 2.155-1.244 2.155-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c0 0 .508-.879 1.244-2.155.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366zm5.5-9.526s-.627 1.087-1.5 2.598c-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.873-1.511 1.5-2.598 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366z" /><path d="m20.48 47.123s-.691 1.196-1.5 2.598c-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.809-1.402 1.5-2.598 1.5-2.598.276-.478.112-1.091-.366-1.367-.478-.275-1.09-.111-1.366.367z" /></g><path d="m24.722 23.836c-.056-.493-.084-1.009-.084-1.549 0-8.278 6.721-15 15-15 7.417 0 13.583 5.395 14.787 12.47 4.046.396 7.213 3.812 7.213 7.962 0 4.398-3.557 7.972-7.949 8h-.051s-23.39.877-50.808-.735c-.24-.016-.435-.2-.464-.439s.116-.464.345-.537c5.091-.926 13.146-2.789 13.435-5.091-.326-.663-.508-1.41-.508-2.198 0-2.759 2.24-5 5-5 1.686 0 3.178.836 4.084 2.117z" fill="#e9f3fc" /><path d="m15.336 35.571c2.985-4.332 7.742-7.348 13.22-7.997 1.326-9.051 9.13-16.01 18.547-16.01 1.129 0 2.234.1 3.31.292 2.058 2.126 3.494 4.858 4.012 7.901 4.046.396 7.213 3.812 7.213 7.962 0 4.398-3.557 7.972-7.949 8h-.051s-16.638.624-38.302-.148z" fill="#cadcf0" /><path d="m32.683 20.719c.828 0 1.5 1.797 1.5 2.625 0 1.035-.672 1.875-1.5 1.875s-1.5-.84-1.5-1.875c0-.828.672-2.625 1.5-2.625z" fill="#738bab" /><path d="m37.265 18.635s-.725.834-1.627.834c-.903 0-1.628-.834-1.628-.834-.184-.205-.501-.222-.706-.038-.206.184-.223.5-.039.706 0 0 1.068 1.166 2.373 1.166s2.372-1.166 2.372-1.166c.184-.206.167-.522-.039-.706-.205-.184-.522-.167-.706.038z" fill="#738bab" /><path d="m47.265 18.635s-.725.834-1.627.834c-.903 0-1.628-.834-1.628-.834-.184-.205-.501-.222-.706-.038-.206.184-.223.5-.039.706 0 0 1.068 1.166 2.373 1.166s2.372-1.166 2.372-1.166c.184-.206.167-.522-.039-.706-.205-.184-.522-.167-.706.038z" fill="#738bab" /><path d="m37.638 28.219c.197 0 .382-.118.461-.308.021-.026.575-.692 2.539-.692 2.002 0 2.539.693 2.539.693s-.01-.025-.01-.025.471.332.471.332c-.383-.076-.099.063.162-.027s.4-.375.31-.636c0 0-.347-1.337-3.472-1.337-3.126 0-3.473 1.337-3.473 1.337-.09.261.049.546.31.636.054.018.109.027.163.027zm.47-.332-.001.004.002-.004z" fill="#738bab" /></g></svg>
                                    <p className="noData text-muted text-center h4 mb-0"><FormattedMessage id="no_friend" /></p>
                                    <p className="mb-3"><FormattedMessage id="invite_friend_to_proceed" /></p>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConfirmPopupHOC(DeletePopupHOC(FriendRequestPopupHOC(observer(FriendRequest))));